import React, { FunctionComponent } from "react";
import classNames from "classnames";

import "./ButtonComponent.scss";

type Props = {
  children: React.ReactNode;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  modifier?: string;
};

const ButtonComponent: FunctionComponent<Props> = ({
  children,
  onClick,
  modifier,
}) => (
  <button
    className={classNames(
      modifier && modifier == "disabled"
        ? "button__disabled "
        : "button button--gold"
    )}
    onClick={onClick}
  >
    {children}
  </button>
);

export default ButtonComponent;
